import React from "react";
import {EditableDiv, EditableImg, smartProps, defineBlock, useEditor, useSmartProp, useInspectorControl, ChildrenBlock} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';
import style from "./block.module.scss";
import classnames from 'classnames';
import colorText from "../shared/color";
import { InnerBlocks } from '@wordpress/block-editor';

function Inspector(){
    const [marginBlock, setMarginBlock] = useSmartProp("marginBlock");
    const [background, setBackground] = useSmartProp("background");
    const [inverseBlock, setInverseBlock] = useSmartProp("inverseBlock");

    return <PanelBody title="Styles" initialOpen={true}>
                <PanelRow>
                    <ToggleControl
                        label="Afficher le fond du bloc"
                        checked={background}
                        onChange={(val) =>setBackground(val)}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label="Remonte le bloc"
                        checked={marginBlock}
                        onChange={(val) =>setMarginBlock(val)}
                    />
                </PanelRow>
                <PanelRow>
                    <ToggleControl
                        label="Inverser les colonnes"
                        checked={inverseBlock}
                        onChange={(val) =>setInverseBlock(val)}
                    />
                </PanelRow>
            </PanelBody>
}

function Block({marginBlock, background, inverseBlock, color}) {
    useInspectorControl(Inspector);
    const {isEditing} = useEditor();

    if(isEditing) {
        colorText(color);
    }

    const blockDesign = classnames({
        [style.bandeau]: true,
        [style.background]: background && true,
        [style.marginB]: marginBlock && true,
        [style.inverseBlock]: inverseBlock && true
    })

    return (
        <div className={blockDesign}>
            <div className={style.column1 + ' ' + (isEditing ? style.adminButtons : style.frontButtons)}>
                <EditableDiv
                    smartProp="title" 
                    tagName={"h2"}
                    className={style.title}
                    allowedFormats={[
                        "core/bold",
                        "advanced/color",
                        [color]
                    ]}
                />
                <EditableDiv
                    smartProp="paragraph" 
                    tagName={"p"}
                    className={style.paragraph}
                    allowedFormats={[
                        "core/bold",
                        "advanced/color",
                        [color]
                    ]}
                /> 
                {
                    isEditing ? 
                        <InnerBlocks
                            allowedBlocks={[
                                "core/paragraph",
                                "core/heading",
                                "core/list",
                                "core/spacer",
                                "core/image",
                                "smartfire/block-button"
                            ]}
                            templateLock={false}
                        />
                    :
                        <ChildrenBlock/>
                }
            </div>
            <div className={style.column2}>
                <EditableImg
                    smartProp="image" 
                    className={!isEditing && style.image}
                    tagName={"div"}
                />
            </div>
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        inverseBlock: smartProps.bool.withDefault(false),
        marginBlock: smartProps.bool.withDefault(false),
        background: smartProps.bool.withDefault(true),
        color: smartProps.any.withDefault(null),
        title: smartProps.string.withDefault("Text ..."),
        paragraph: smartProps.string.withDefault("Text ..."),
        image: smartProps.any.withDefault(null),
    },
    setup: {
        title: "Bandeau 2 colonnes"
    }
});